'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100% !important;\n  margin-bottom: 5px;\n  ', '\n\n  > div {\n    bottom: 0px;\n    line-height: 15px;\n  }\n\n  label {\n    top: 5px !important;\n    left: 5px !important;\n    font-size: 12px;\n  }\n\n  hr {\n    bottom: 0 !important;\n  }\n\n  .mozart-textbox-disabled {\n    hr {\n      border-bottom: none !important;\n    }\n  }\n\n  .mozart-textbox-binary_input {\n    width: 100% !important;\n    margin-bottom: 40px;\n    margin-top: 20px;\n\n    div {\n      bottom: 0px !important;\n    }\n\n    label {\n      top: 5px !important;\n      left: 5px !important;\n      font-size: 12px;\n    }\n\n    hr {\n      bottom: 0 !important;\n    }\n\n    input {\n      border: 1px solid #CCC !important;\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n      padding: 0px 12px !important;\n      font-size: 14px !important;\n    }\n  }\n\n  .mozart-textbox-binary_text_box {\n    width: 100% !important;\n    margin-bottom: 5px;\n\n    div {\n      bottom: 0px !important;\n      line-height: 3px !important;\n\n      textarea {\n        line-height: 18px !important;\n      }\n    }\n\n    label {\n      top: 5px !important;\n      left: 5px !important;\n      font-size: 12px;\n    }\n\n    hr {\n      bottom: 0 !important;\n    }\n\n  }\n\n  .autocomplete_item {\n    display: block;\n    cursor: pointer;\n    padding: 5px;\n\n    strong {\n      font-weight: 900;\n      text-decoration: underline;\n    }\n  }\n  div.iconContainer span {\n    height: 40px;\n    line-height: 3em;\n    position: absolute;\n    width: 40px;\n    color: ', ';\n    border-radius: 5px;\n    background-color: ', ';\n    cursor: pointer;\n    z-index: 1;\n    text-align: center;\n  }\n'], ['\n  width: 100% !important;\n  margin-bottom: 5px;\n  ', '\n\n  > div {\n    bottom: 0px;\n    line-height: 15px;\n  }\n\n  label {\n    top: 5px !important;\n    left: 5px !important;\n    font-size: 12px;\n  }\n\n  hr {\n    bottom: 0 !important;\n  }\n\n  .mozart-textbox-disabled {\n    hr {\n      border-bottom: none !important;\n    }\n  }\n\n  .mozart-textbox-binary_input {\n    width: 100% !important;\n    margin-bottom: 40px;\n    margin-top: 20px;\n\n    div {\n      bottom: 0px !important;\n    }\n\n    label {\n      top: 5px !important;\n      left: 5px !important;\n      font-size: 12px;\n    }\n\n    hr {\n      bottom: 0 !important;\n    }\n\n    input {\n      border: 1px solid #CCC !important;\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n      padding: 0px 12px !important;\n      font-size: 14px !important;\n    }\n  }\n\n  .mozart-textbox-binary_text_box {\n    width: 100% !important;\n    margin-bottom: 5px;\n\n    div {\n      bottom: 0px !important;\n      line-height: 3px !important;\n\n      textarea {\n        line-height: 18px !important;\n      }\n    }\n\n    label {\n      top: 5px !important;\n      left: 5px !important;\n      font-size: 12px;\n    }\n\n    hr {\n      bottom: 0 !important;\n    }\n\n  }\n\n  .autocomplete_item {\n    display: block;\n    cursor: pointer;\n    padding: 5px;\n\n    strong {\n      font-weight: 900;\n      text-decoration: underline;\n    }\n  }\n  div.iconContainer span {\n    height: 40px;\n    line-height: 3em;\n    position: absolute;\n    width: 40px;\n    color: ', ';\n    border-radius: 5px;\n    background-color: ', ';\n    cursor: pointer;\n    z-index: 1;\n    text-align: center;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 10px 18px;\n  position: relative;\n  width: 100%;\n  height: 40px;\n  outline: none;\n  font-style: inherit;\n  font-variant: inherit;\n  font-weight: 400;\n  font-stretch: inherit;\n  font-size: 15px;\n  line-height: inherit;\n  font-family: inherit;\n  border-radius: 5px;\n\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 5px;\n  padding: ', ';\n  color: ', ';\n'], ['\n  padding: 10px 18px;\n  position: relative;\n  width: 100%;\n  height: 40px;\n  outline: none;\n  font-style: inherit;\n  font-variant: inherit;\n  font-weight: 400;\n  font-stretch: inherit;\n  font-size: 15px;\n  line-height: inherit;\n  font-family: inherit;\n  border-radius: 5px;\n\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 5px;\n  padding: ', ';\n  color: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  height: 100%;\n  width: 100%;\n  resize: none;\n  font-style: inherit;\n  font-variant: inherit;\n  font-weight: 400;\n  font-stretch: inherit;\n  font-size: 15px;\n  line-height: inherit;\n  font-family: inherit;\n  padding: 18px;\n  cursor: initial;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  position: relative;\n  border: 1px solid ', ';\n  outline: none;\n  background-color: rgba(0, 0, 0, 0);\n  color: ', ';\n  margin-top: 12px;\n  margin-bottom: -12px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  min-height: 200px;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 11px -2px;\n'], ['\n  height: 100%;\n  width: 100%;\n  resize: none;\n  font-style: inherit;\n  font-variant: inherit;\n  font-weight: 400;\n  font-stretch: inherit;\n  font-size: 15px;\n  line-height: inherit;\n  font-family: inherit;\n  padding: 18px;\n  cursor: initial;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  position: relative;\n  border: 1px solid ', ';\n  outline: none;\n  background-color: rgba(0, 0, 0, 0);\n  color: ', ';\n  margin-top: 12px;\n  margin-bottom: -12px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  min-height: 200px;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 11px -2px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  top: 5px;\n  float: right;\n  color: ', ';\n'], ['\n  top: 5px;\n  float: right;\n  color: ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: auto;\n  right: 10px;\n  background-color: #FFF;\n  border: 1px solid #CCC;\n  z-index: 99999;\n  margin-top: -20px;\n  min-height: 90px;\n\n  .autocomplete_item {\n    display: block;\n    cursor: pointer;\n    padding: 5px;\n\n    strong {\n      font-weight: 900;\n      text-decoration: underline;\n    }\n  }\n\n  .autocomplete_item:hover {\n    background-color: #E0ECF8;\n  }\n'], ['\n  position: absolute;\n  bottom: auto;\n  right: 10px;\n  background-color: #FFF;\n  border: 1px solid #CCC;\n  z-index: 99999;\n  margin-top: -20px;\n  min-height: 90px;\n\n  .autocomplete_item {\n    display: block;\n    cursor: pointer;\n    padding: 5px;\n\n    strong {\n      font-weight: 900;\n      text-decoration: underline;\n    }\n  }\n\n  .autocomplete_item:hover {\n    background-color: #E0ECF8;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: 10px;\n  font-size: 12px;\n  color: red;\n'], ['\n  position: absolute;\n  bottom: 10px;\n  font-size: 12px;\n  color: red;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactTinymce = require('react-tinymce');

var _reactTinymce2 = _interopRequireDefault(_reactTinymce);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BinaryTextBoxContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.icon ? 'display: flex;' : '';
}, _color2.default.white, _color2.default.blue_main);

var TextBox = _styledComponents2.default.input(_templateObject2, _color2.default.white, _color2.default.blue_accent, function (props) {
  return props.icon ? '10px 45px' : '10px 18px';
}, _color2.default.grey_main);

var TextBoxArea = _styledComponents2.default.textarea(_templateObject3, _color2.default.blue_main, _color2.default.grey_main);

var ErrorText = _styledComponents2.default.div(_templateObject4, _color2.default.r34);

var AutoCompleteContainer = _styledComponents2.default.div(_templateObject5);

var rteError = _styledComponents2.default.div(_templateObject6);

var MozartTextBox = function (_Component) {
  _inherits(MozartTextBox, _Component);

  function MozartTextBox(props) {
    _classCallCheck(this, MozartTextBox);

    var _this = _possibleConstructorReturn(this, (MozartTextBox.__proto__ || Object.getPrototypeOf(MozartTextBox)).call(this, props));

    _this.state = {
      errorText: '',
      default_value: '',
      autocomplete_items: []
    };
    if (!_this.props.disabled && (!_this.props.defaultValue || _this.props.defaultValue === '')) {
      if (!(_this.props.value && String(_this.props.value).trim().length > 0)) {
        _this.state.errorText = _this.props.name ? 'Please enter a value for ' + _this.props.name : 'This field is required';
      }
    }
    if (_this.props.defaultValue && _this.state.errorText === '') {
      _this.state.errorText = _this.getErrors(_this.props.defaultValue);
    }
    return _this;
  }

  _createClass(MozartTextBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var defaultValue = this.props.defaultValue;

      if (defaultValue) {
        this.onChange({ target: { value: defaultValue } });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          unControlled = _props.unControlled;

      if (nextProps.value !== value && !unControlled) {
        this.setState({
          value: nextProps.value
        }, function () {
          _this2.onChange({ target: { value: nextProps.value } });
        });
      }
    }
  }, {
    key: 'stripNonNumeric',
    value: function stripNonNumeric(value) {
      return value.replace(/[^0-9]/g, '');
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      var _this3 = this;

      var _props2 = this.props,
          autocomplete = _props2.autocomplete,
          onChange = _props2.onChange,
          stripNonNumeric = _props2.stripNonNumeric,
          regexReplace = _props2.regexReplace,
          allowNewLine = _props2.allowNewLine;

      var value = allowNewLine ? event.target.value : String(event.target.value).replace(/\n/g, ' ');
      var autocompleteItems = autocomplete ? this.getAutoComplete(value) : [];
      var errors = this.getErrors(value);
      var remainingCharacterCount = this.getRemainingCharacters(value);

      // strip non numeric
      if (stripNonNumeric) {
        value = this.stripNonNumeric(value);
      }

      // regex replacement
      if (regexReplace) {
        value = value.replace(regexReplace, '');
      }

      this.setState({
        autocomplete_items: autocompleteItems.slice(0, 10),
        default_value: value,
        errorText: errors.length > 0 ? errors[0] : '',
        remainingCharacterCount: remainingCharacterCount
      }, function () {
        if (onChange) {
          onChange(_this3.replaceAutoComplete(value));
        }
        if (stripNonNumeric || regexReplace) {
          if (_reactDom2.default.findDOMNode(_this3.refs[_this3.props.ref])) {
            _reactDom2.default.findDOMNode(_this3.refs[_this3.props.ref]).value = value;
          }
        }
      });
    }
  }, {
    key: 'getRemainingCharacters',
    value: function getRemainingCharacters(value) {
      var limit = this.props.limit;

      if (String(value).length < limit) {
        var remainingCharacterCount = limit - String(value).length;
        if (remainingCharacterCount > 0) {
          return limit - String(value).length + ' characters remaining';
        } else {
          return '';
        }
      }
    }
  }, {
    key: 'getErrors',
    value: function getErrors(value) {
      var _props3 = this.props,
          name = _props3.name,
          validatePhone = _props3.validatePhone,
          validateNumeric = _props3.validateNumeric,
          validateAtLeastOneAlphabet = _props3.validateAtLeastOneAlphabet,
          validateEmail = _props3.validateEmail,
          validateUserName = _props3.validateUserName,
          validatePassword = _props3.validatePassword;

      var errors = [];
      var emptyError = this.getEmptyError(value, name);
      if (emptyError.length > 0) {
        errors.push(emptyError);
      }
      if (this.checkEmpty(value)) {
        errors.push('Please enter a value for ' + name);
      }
      if (!this.checkLimit(value)) {
        errors.push('Maximum of ' + this.props.limit + ' characters');
      }
      var minCharsError = this.getMinCharsError(value);
      if (minCharsError.length > 0) {
        errors.push(minCharsError);
      }
      if (validateNumeric && this.checkNumeric(value)) {
        errors.push(name + ' cannot contain only numbers');
      }
      if (validateEmail && !this.checEmail(value)) {
        errors.push('Invalid email address');
      }
      if (validatePhone && !this.checkPhone(value)) {
        errors.push('Invalid phone number');
      }
      if (validateUserName && !this.checkUserName(value)) {
        errors.push(name + ' must contain only alphabet and number');
      }
      if (validatePassword && !this.checkPassword(value)) {
        errors.push('Password must contain at least one uppercase alphabet, one lowercase alphabet and one numeric.');
      }
      if (validateAtLeastOneAlphabet && !this.checkAtLeastOneAlphabet(value)) {
        errors.push(name + ' must contain at least one alphabet character.');
      }
      return errors;
    }
  }, {
    key: 'getEmptyError',
    value: function getEmptyError(value, name) {
      var emptyLabel = this.props.emptyLabel;

      var error = '';
      if (this.checkEmpty(value)) {
        if (emptyLabel) {
          error = emptyLabel;
        } else {
          error = 'Please enter a value for ' + name;
        }
      }
      return error;
    }
  }, {
    key: 'getMinCharsError',
    value: function getMinCharsError(value) {
      var minCharsLabel = this.props.minCharsLabel;

      var error = '';
      if (!this.checkMinChars(value)) {
        if (minCharsLabel) {
          error = minCharsLabel;
        } else {
          error = 'Required at least ' + (parseInt(this.props.minChars, 10) + 1) + ' characters';
        }
      }
      return error;
    }
  }, {
    key: 'getAutoComplete',
    value: function getAutoComplete(value) {
      var autocomplete = this.props.autocomplete;

      var autocompleteItems = [];
      if (value.indexOf('@') !== -1) {
        var valueToFind = value.toLowerCase().slice(value.indexOf('@'), value.length);
        if (valueToFind !== '@') {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = autocomplete[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.name.toLowerCase().indexOf(valueToFind.replace('@', '')) === 0) {
                var autocompleteItem = item.name + ' - ' + item.id;
                var autocompleteItemHighLight = autocompleteItem.toLowerCase().replace(valueToFind.replace('@', ''), '<strong>' + valueToFind.replace('@', '') + '</strong>');
                autocompleteItems.push(_react2.default.createElement('span', { onClick: this.handleAutoCompleteClick.bind(this, item), className: 'autocomplete_item', key: item.id, dangerouslySetInnerHTML: { __html: autocompleteItemHighLight } }));
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }
      return autocompleteItems;
    }
  }, {
    key: 'handleRTEChange',
    value: function handleRTEChange(editor) {
      var onChange = this.props.onChange;

      onChange(editor.target.getContent());
    }
  }, {
    key: 'handleRTEKeypress',
    value: function handleRTEKeypress(event, editor) {
      var customevent = void 0; // The custom event that will be created
      if (event.charCode === 94) {
        event.preventDefault();
      }
      if (document.createEvent) {
        customevent = document.createEvent('HTMLEvents');
        customevent.initEvent('keypress', true, true);
      } else {
        customevent = document.createEventObject();
        customevent.eventType = 'keypress';
      }
      customevent.eventName = 'keypress';
      customevent.charCode = event.charCode;
      customevent.customTarget = event.target;
      customevent.editor = editor;
      if (document.createEvent) {
        document.dispatchEvent(customevent);
      } else {
        document.fireEvent('on' + customevent.eventType, customevent);
      }
    }
  }, {
    key: 'handleAutoCompleteClick',
    value: function handleAutoCompleteClick(item) {
      var _this4 = this;

      var onChange = this.props.onChange;

      var initialData = this.state.default_value.slice(0, this.state.default_value.indexOf('@'));
      this.setState({
        default_value: initialData + '[~' + item.name.split(' ').join('_') + ']',
        autocomplete_items: []
      }, function () {
        _reactDom2.default.findDOMNode(_this4.refs.binary_text_box).getElementsByTagName('textarea')[0].value = _this4.state.default_value;
        _reactDom2.default.findDOMNode(_this4.refs.binary_text_box).getElementsByTagName('textarea')[1].value = _this4.state.default_value;
        _reactDom2.default.findDOMNode(_this4.refs.binary_text_box).getElementsByTagName('textarea')[0].focus();
        _reactDom2.default.findDOMNode(_this4.refs.binary_text_box).getElementsByTagName('textarea')[1].focus();

        if (onChange) {
          onChange(_this4.replaceAutoComplete(_this4.state.default_value));
        }
      });
    }
  }, {
    key: 'replaceAutoComplete',
    value: function replaceAutoComplete(value) {
      var autocomplete = this.props.autocomplete;

      var valueAutoComplete = value;
      if (autocomplete) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = autocomplete[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            valueAutoComplete = this.replaceAll('[~' + item.name.split(' ').join('_') + ']', valueAutoComplete, '[' + btoa(item.id) + '|' + item.name + ']');
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      return valueAutoComplete;
    }
  }, {
    key: 'replaceAll',
    value: function replaceAll(search, target, replacement) {
      return target.split(search).join(replacement);
    }
  }, {
    key: 'checkEmpty',
    value: function checkEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    }
  }, {
    key: 'checkLimit',
    value: function checkLimit(value) {
      var limit = this.props.limit;

      return String(value).length < limit || String(value).length === limit;
    }
  }, {
    key: 'checkMinChars',
    value: function checkMinChars(value) {
      var minChars = this.props.minChars;

      return String(value).length > minChars;
    }
  }, {
    key: 'checkNumeric',
    value: function checkNumeric(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    }
  }, {
    key: 'checEmail',
    value: function checEmail(value) {
      var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(value);
    }
  }, {
    key: 'checkPhone',
    value: function checkPhone(value) {
      var regex = /^\d{10}$/;
      return regex.test(value);
    }
  }, {
    key: 'checkPassword',
    value: function checkPassword(value) {
      var checkLowerCase = /[a-z]/.test(value);
      var checkUpperCase = /[A-Z]/.test(value);
      var checkNumber = /\d/.test(value);
      return checkLowerCase && checkUpperCase && checkNumber;
    }
  }, {
    key: 'checkAtLeastOneAlphabet',
    value: function checkAtLeastOneAlphabet(value) {
      return value.trim().toLowerCase().match(/[a-z]/i) !== null;
    }
  }, {
    key: 'checkUserName',
    value: function checkUserName(value) {
      var regex = /^[a-zA-Z0-9]+$/;
      return regex.test(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props4 = this.props,
          ref = _props4.ref,
          emptyLabel = _props4.emptyLabel,
          multiLine = _props4.multiLine,
          type = _props4.type,
          validationBool = _props4.validationBool,
          rte = _props4.rte,
          keyPress = _props4.keyPress,
          limit = _props4.limit,
          customClassName = _props4.customClassName,
          defaultValue = _props4.defaultValue,
          value = _props4.value,
          _onKeyPress = _props4.onKeyPress,
          hintText = _props4.hintText,
          icon = _props4.icon,
          style = _props4.style,
          disabled = _props4.disabled,
          rteHeight = _props4.rteHeight,
          themeId = _props4.themeId,
          showRemainingCharacter = _props4.showRemainingCharacter;

      var classNameDisabled = disabled ? '.mozart-textbox-disabled' : '';
      var classNameExtra = customClassName ? customClassName : '';
      return _react2.default.createElement(
        'div',
        { ref: 'binary_text_box', 'data-qa': this.props.testId, 'data-theme': themeId },
        _react2.default.createElement(
          BinaryTextBoxContainer,
          { multiLine: multiLine, icon: icon },
          _react2.default.createElement(
            'div',
            { className: 'iconContainer' },
            icon
          ),
          !rte && !multiLine && _react2.default.createElement(
            'div',
            { style: { width: '100%' } },
            _react2.default.createElement(TextBox, {
              type: type,
              defaultValue: value ? value : defaultValue,
              disabled: disabled,
              id: this.props.id,
              'data-qa': this.props.testId + '_TextBox',
              name: this.props.name,
              ref: ref,
              icon: icon
              // emptyLabel={this.props.emptyLabel}
              // multiLine={false}
              // customClassName={this.props.customClassName}
              // hintText={hintText}
              , placeholder: value.length === 0 && emptyLabel ? emptyLabel : hintText,
              className: '.mozart-textbox-binary_text_box' + classNameDisabled + ' ' + classNameExtra,
              maxLength: String(limit),
              style: style,
              onChange: this.onChange.bind(this),
              onBlur: function onBlur(event) {
                if (_this5.props.onBlur) {
                  _this5.props.onBlur(event);
                }
              },
              onKeyPress: function onKeyPress(event) {
                if (_onKeyPress) {
                  _onKeyPress(event);
                }
              }
            }),
            _react2.default.createElement(
              ErrorText,
              null,
              validationBool ? this.state.errorText : '',
              this.state.errorText === undefined && showRemainingCharacter ? this.state.remainingCharacterCount : ''
            )
          ),
          !rte && multiLine && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(TextBoxArea, {
              ref: ref,
              style: style,
              defaultValue: value ? value : defaultValue,
              disabled: disabled,
              id: this.props.id,
              'data-qa': this.props.testId + '_TextBoxArea',
              name: this.props.name,
              placeholder: value.length === 0 && emptyLabel ? emptyLabel : hintText,
              className: multiLine ? 'mozart-textbox-binary_text_box ' + classNameDisabled + ' ' + classNameExtra : '.mozart-textbox-binary_input ' + classNameDisabled + ' ' + classNameExtra,
              maxLength: limit,
              onChange: this.onChange.bind(this),
              onBlur: function onBlur(event) {
                if (_this5.props.onBlur) {
                  _this5.props.onBlur(event);
                }
              }
            }),
            _react2.default.createElement(
              ErrorText,
              null,
              validationBool ? this.state.errorText : '',
              showRemainingCharacter && !this.state.errorText ? this.state.remainingCharacterCount : ''
            )
          ),
          rte && _react2.default.createElement(_reactTinymce2.default, {
            ref: ref,
            content: defaultValue,
            className: customClassName,
            id: 'binary_text_rte',
            'data-qa': this.props.testId + '_text_rte',
            config: {
              elementpath: false,
              body_class: 'no-margin',
              height: rteHeight,
              menubar: false,
              resize: false,
              visual: false,
              plugins: ['noneditable textcolor lists'],
              toolbar: 'undo redo | bold italic underline | fontselect fontsizeselect | bullist numlist | alignleft aligncenter alignright | forecolor backcolor'
            },
            onChange: this.handleRTEChange.bind(this),
            onKeypress: keyPress ? this.handleRTEKeypress.bind(this) : ''
          }),
          rte && this.state.errorText !== '' && _react2.default.createElement(
            'rteError',
            null,
            validationBool && this.state.errorText
          ),
          rte && this.props.disabled && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.getCurrentRichData() } })
        ),
        this.state.autocomplete_items.length > 0 && _react2.default.createElement(
          AutoCompleteContainer,
          null,
          this.state.autocomplete_items
        )
      );
    }
  }]);

  return MozartTextBox;
}(_react.Component);

MozartTextBox.propTypes = {
  /** theme attribute */
  themeId: _propTypes2.default.string,
  ref: _propTypes2.default.string,
  id: _propTypes2.default.string,
  /** textbox type text textarea or file */
  type: _propTypes2.default,
  /** to show place holder Please enter a value for ${name} */
  name: _propTypes2.default.string,
  /** single or multiple line */
  multiLine: _propTypes2.default.bool,
  /** disable editing */
  disabled: _propTypes2.default.bool,
  /** empty error text */
  emptyLabel: _propTypes2.default.string,
  /** minimum characters */
  minChars: _propTypes2.default.number,
  /** minimum characters validation text */
  minCharsLabel: _propTypes2.default.string,
  /** limit number of characters */
  limit: _propTypes2.default.number,
  /** default value */
  defaultValue: _propTypes2.default.string,

  /** rich text editor */
  rte: _propTypes2.default.bool,
  /** specify rich text editor height (not sure why the lib only takes string) */
  rteHeight: _propTypes2.default.string,

  /** regex replace */
  regexReplace: _propTypes2.default.object,

  /** strip non number */
  stripNonNumeric: _propTypes2.default.bool,

  /** turn on validation */
  validationBool: _propTypes2.default.bool,
  /** turn on at least one alphabet character validation */
  validateAtLeastOneAlphabet: _propTypes2.default.bool,
  /** turn on at least one number validation */
  validateNumeric: _propTypes2.default.bool,
  /** turn on email validation */
  validateEmail: _propTypes2.default.bool,
  /** turn on password validation */
  validatePassword: _propTypes2.default.bool,
  /** turn on username validation */
  validateUserName: _propTypes2.default.bool,
  /** turn on phone validation */
  validatePhone: _propTypes2.default.bool,

  /** on change callback */
  onChange: _propTypes2.default.func,
  /** on blur callback */
  onBlur: _propTypes2.default.func,
  /** turn on keypress listener */
  keyPress: _propTypes2.default.bool,
  /** on keypress callback */
  onKeyPress: _propTypes2.default.func,

  /** array of object {id: id, name: name} when onChange get called */
  autocomplete: _propTypes2.default.array,
  /** custom class name */
  customClassName: _propTypes2.default.string,

  /** hint in textbox */
  hintText: _propTypes2.default.string,
  /** pass icon if input need it */
  icon: _propTypes2.default.node,

  unControlled: _propTypes2.default.bool,
  value: _propTypes2.default.string,
  /** show remaing character*/
  showRemainingCharacter: _propTypes2.default.bool,
  /** allow enter character*/
  allowNewLine: _propTypes2.default.bool
};
MozartTextBox.defaultProps = {
  testId: 'MozartTextBox',
  themeId: 'MozartTextBox',
  id: 'binary_text_box_' + Math.random(),
  ref: 'binary_text_box_' + Math.random(),
  disabled: false,
  value: '',
  errorText: '',
  limit: 3000,
  minChars: 0,
  multiLine: false,
  rte: false,
  validateAtLeastOneAlphabet: false,
  validateNumeric: false,
  validateEmail: false,
  validatePassword: false,
  validateUserName: false,
  validatePhone: false,
  validationBool: true,
  keyPress: false,
  rteHeight: '200',
  unControlled: false,
  stripNonNumeric: false,
  showRemainingCharacter: false,
  allowNewLine: false
};
exports.default = MozartTextBox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartTextBox/MozartTextBox.js
// module id = 311
// module chunks = 1